var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-menu"}},[_vm._m(0),_c('sidebar-menu',{attrs:{"menu":_vm.menu,"theme":"black-theme","width":"20vw","showOneChild":true,"hide-toggle":true}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hover-leftline pt-4 px-3 sidebar"},[_c('img',{staticClass:"topbar-logo",attrs:{"src":require("@/assets/images/spade-logo.png")}}),_c('br')])
}]

export { render, staticRenderFns }